import { ReactiveController, ReactiveControllerHost } from 'lit'
import { baseUrl, resolveUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'

/**
 * Resolves paths against the enterprise domain base url from within a synchronous `render()`.
 *
 * The base url is provided asynchronously by `csc-enterprise-domains`, so the controller
 * resolves it once on connect, caches it and requests an update. Renders before it arrives
 * return an empty string; every render after it is fully synchronous.
**/
export class BaseUrlController implements ReactiveController {
  private base?: string

  constructor(private host: ReactiveControllerHost) {
    host.addController(this)
  }

  hostConnected(): void {
    if (this.base !== undefined) {
      return
    }

    baseUrl()
      .then(base => {
        this.base = base
        this.host.requestUpdate()
      })
      .catch(error => console.warn('could not resolve the base url', error))
  }

  path(path: string): string {
    return this.base === undefined ? '' : resolveUrl(this.base, path).pathname
  }

  href(path: string): string {
    return this.base === undefined ? '' : resolveUrl(this.base, path).href
  }
}
